import { defineStore } from 'pinia';

export const useCheckoutStore = defineStore('checkout', {
    state: () => ({
        step: 1,
        customerData: {
            email: '',
            emailConfirmation: '',
            firstname: '',
            lastname: '',
            telephonePrefix: 'FIN|358',
            telephoneNumber: '',
            marketing: [],
        },
        sendSms: false,
        busy: false,
        orderId: '',
        paymentMethodType: '',
        bank: '',
        card: '',
    }),
    actions: {
        clear() {
            this.customerData = {
                email: '',
                emailConfirmation: '',
                firstname: '',
                lastname: '',
                telephonePrefix: 'FIN|358',
                telephoneNumber: '',
                marketing: [],
            };
            localStorage.clear();
        },
        loadFromLocal() {
            if (!window || !window.localStorage.getItem('userinfo')) return;
            this.customerData = JSON.parse(window.localStorage.getItem('userinfo'));
        },
        saveToLocal() {
            localStorage.setItem('userinfo', JSON.stringify(this.customerData));
        },
    },
    getters: {
        getCustomerData: state => state.customerData,
        getBusy: state => state.busy,
        getOrderId: state => state.orderId,
    },
});
